import TrendingList from "./trendingList/trendingList.component";
import SearchList from "./searchList/searchList.component";

export {TrendingList, SearchList}